export default function () {
  const storeInfo_formConfig = [
    {
      el: 'text',
      itemConfig: {
        label: '门店名称',
        prop: 'name',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '联系电话',
        prop: 'contactTel',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '省份',
        prop: 'provinceName',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '门店城市',
        prop: 'cityName',
      },
    },
    {
      el: 'text',
      itemConfig: {
        label: '地址',
        prop: 'address',
      },
    },
    {
      el: 'checkbox',
      itemConfig: {
        label: '司机到店所需证件',
        prop: 'needLicenseType',
      },
      elConfig: {
        disabled: true,
        options: {
          label: 'label',
          value: 'value',
          list: [
            {
              label: '身份证',
              value: 10,
              disabled: true,
            },
            {
              label: '驾驶证',
              value: 20,
              disabled: true,
            },
            {
              label: '银行卡',
              value: 30,
              disabled: true,
            },
            {
              label: '网约车驾驶证',
              value: 40,
            },
          ],
        },
      },
    },
    {
      el: 'image',
      itemConfig: {
        label: '企微二维码',
        prop: 'contactQRCode',
      },
      elConfig: {
        render: 'EnlargeImg',
        listType: 'img',
        imgSrc: '',
      },
    },
  ]
  const storeInfo_model = {
    name: '',
    contactTel: '',
    provinceCode: '',
    cityCode: '',
    address: '',
    needLicenseType: [],
    contactQRCode: '',
  }
  return {
    storeInfo_formConfig,
    storeInfo_model,
  }
}
